import React, { useState } from "react";
import { ModalXoa } from "./ModalXoa";

export const BtnXoa = ({ item, onReload }) => {
    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    };
    return (
        <>
            <button
                type="button"
                className="btn btn-border-new"
                onClick={handleShow}
                title="Xóa"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    border: 'none',
                    gap: '3px',
                    padding: 0,
                    backgroundColor: 'transparent',
                    cursor: 'pointer'
                }}
            >
                <img
                    src="/app-assets/images/icon-xoa-v2.png"
                    alt="Xóa"
                    style={{ width: '20px', height: 'auto', display: 'block' }}
                />
                <span style={{
                    color: 'rgb(43, 51, 94)',
                    fontSize: '16px',
                    lineHeight: '1',
                    marginTop: '2px'
                }}>
                    Xóa
                </span>
            </button>
            {show && (
                <ModalXoa
                    id={item.CustomerId}
                    dbName={item.DBName}
                    show={show}
                    onHide={() => setShow(false)}
                    onSaved={() => { setShow(false); onReload(); }}
                />
            )}
        </>
    );
};